/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Seating_IncompleteInputs */



/**
* | output |
* | --- |
* | "Submitted seating does not include all selected players" |
*
* @param {Err_Tournament_Seating_IncompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_seating_incomplete = /** @type {((inputs?: Err_Tournament_Seating_IncompleteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Seating_IncompleteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le placement soumis n'inclut pas tous les joueurs sélectionnés")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los asientos enviados no incluyen a todos los jugadores seleccionados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os assentos enviados não incluem todos os jogadores selecionados")
	if (locale === "it") return /** @type {LocalizedString} */ ("La disposizione inviata non include tutti i giocatori selezionati")
	return /** @type {LocalizedString} */ ("Submitted seating does not include all selected players")
});